<template>
  <button 
    class="action-button"
    :class="[variant, { 'loading': loading }]"
    :disabled="disabled || loading"
    @click="$emit('click')"
  >
    <v-icon v-if="leftIcon && !loading">{{ leftIcon }}</v-icon>
    <slot></slot>
    <v-icon v-if="rightIcon && !loading">{{ rightIcon }}</v-icon>
    <v-progress-circular v-if="loading" indeterminate size="20" class="ml-2"></v-progress-circular>
  </button>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary', 'text', 'danger'].includes(value)
    },
    leftIcon: {
      type: String,
      default: ''
    },
    rightIcon: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click']
}
</script>

<style scoped>
.action-button {
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.action-button.primary {
  background-color: #e94057;
  color: white;
}

.action-button.primary:hover:not(:disabled) {
  background-color: #d03a4e;
}

.action-button.secondary {
  background-color: #f0f0f0;
  color: #333;
}

.action-button.secondary:hover:not(:disabled) {
  background-color: #e0e0e0;
}

.action-button.text {
  background-color: transparent;
  color: #333;
  padding: 8px 16px;
}

.action-button.text:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.05);
}

.action-button.danger {
  background-color: #f44336;
  color: white;
}

.action-button.danger:hover:not(:disabled) {
  background-color: #d32f2f;
}

.action-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.action-button.loading {
  opacity: 0.8;
}
</style> 